import axios from "axios";

const rawBackend = process.env.REACT_APP_BACKEND_URL;
export const API_URL = (rawBackend == null ? "" : String(rawBackend)).replace(/\/$/, "");
export const API = API_URL ? `${API_URL}/api` : "/api";

const mediaOrigin = () => {
  if (API_URL) return API_URL;
  if (typeof window !== "undefined") return window.location.origin;
  return "";
};

/** URL media selalu ke backend aktif (satu domain di production, atau localhost saat development). */
export const resolveMediaUrl = (url) => {
  if (!url) return url;
  const mediaMatch = String(url).match(/\/api\/media\/([A-Za-z0-9-]+)(\?.*)?$/);
  if (mediaMatch) {
    const origin = mediaOrigin();
    return origin
      ? `${origin}/api/media/${mediaMatch[1]}${mediaMatch[2] || ""}`
      : `/api/media/${mediaMatch[1]}${mediaMatch[2] || ""}`;
  }
  return url;
};

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mandala_token");
  if (token) {
    config.headers = config.headers || {};
    if (typeof config.headers.set === "function") {
      config.headers.set("Authorization", `Bearer ${token}`);
    } else {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    const isAuthError =
      status === 401 &&
      (detail === "Not authenticated" ||
        detail === "Token expired" ||
        detail === "Invalid token" ||
        detail === "Invalid token type" ||
        detail === "User not found");

    if (isAuthError && typeof window !== "undefined") {
      localStorage.removeItem("mandala_token");
      if (!window.location.pathname.startsWith("/admin/login")) {
        window.location.assign("/admin/login");
      }
    }
    return Promise.reject(error);
  }
);

export const WA = (number, template) => {
  const n = (number || "628133187729").replace(/\D/g, "");
  const t = encodeURIComponent(template || "Halo, saya ingin bertanya tentang layanan maklon minuman Mandala.");
  return `https://api.whatsapp.com/send?phone=${n}&text=${t}`;
};

/** Extract YouTube video id / embed URL from common link formats. Returns null if invalid. */
export const getYoutubeEmbedUrl = (url) => {
  if (!url || typeof url !== "string") return null;
  const raw = url.trim();
  if (!raw) return null;

  let id = null;
  const patterns = [
    /(?:youtube\.com\/watch\?(?:[^#]*&)?v=|youtube\.com\/embed\/|youtube\.com\/shorts\/|youtu\.be\/)([A-Za-z0-9_-]{6,})/i,
    /^([A-Za-z0-9_-]{11})$/,
  ];
  for (const re of patterns) {
    const m = raw.match(re);
    if (m?.[1]) {
      id = m[1];
      break;
    }
  }
  if (!id) return null;
  return `https://www.youtube.com/embed/${id}?rel=0`;
};

export const trackEvent = (type, page, label = "") => {
  const device = /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop";
  api.post("/analytics/track", {
    event_type: type,
    page,
    label,
    referrer: document.referrer || "",
    user_agent: navigator.userAgent,
    device,
  }).catch(() => {});
};

export const formatApiError = (detail) => {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (typeof detail === "object" && typeof detail.detail === "string") return detail.detail;
  if (typeof detail === "object" && typeof detail.message === "string") return detail.message;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
